import { render, staticRenderFns } from "./InfoService.vue?vue&type=template&id=6322b9b8&scoped=true"
import script from "./InfoService.vue?vue&type=script&lang=js"
export * from "./InfoService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6322b9b8",
  null
  
)

export default component.exports